import React, { Suspense, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useLocation, useNavigate } from 'react-router-dom';
import { getApi } from '../../Services/apiService';
import AddEventModal from './addEvent';
import EditEventModal from './editEvent';
import DeleteModal from './deleteEvent';

export default function Event() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(0);
  const [filterCategory, setFilterCategory] = useState(''); // Filter state
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [addEventModal, setAddEventModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();  

  const categories = [
    { id: 0, name: 'All' },
    { id: 1, name: 'Upcoming Events' },
    { id: 2, name: 'Past Events' },
  ];

  const filterOptions = [
    { id: '', name: 'All Categories' },
    { id: 0, name: 'Music' },
    { id: 1, name: 'Food & Drink' },
    { id: 2, name: 'Themed Nights' },
    { id: 3, name: 'Nightclubs & Guest Lists' },
  ];

  const openAddModal = () => setAddEventModal(true);
  const openDeleteUserModal = (eventDetails) => {
    setSelectedEvent(eventDetails);
    setDeleteModal(true);
  };
  const openEditVenueModal = (eventDetails) => {
    setSelectedEvent(eventDetails);
    setEditModal(true);
  };

  const fetchEvents = async () => {
    setLoading(true);
    setError(null);
  
    try {
      const endpoint = `/admin/events?search=${searchTerm}&status=${activeCategory}&type=${filterCategory}`;
      const response = await getApi(endpoint);
  
      if (response && response.status === 200) {
        setEvents(response.data.events);
      } else {
        throw new Error('Failed to fetch events.');
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [activeCategory, searchTerm, filterCategory]);

  return (
    <>
      {loading && <div className="loader"><div className="spinner"></div></div>}
      {error && <p className="error-message">{error}</p>}

      <div className={`${location.pathname.includes('event') ? 'RightSideDiv' : ''} ${loading ? 'blurred' : ''}`}>
        <div className='car-care-tips'>
          <div className="header">
            <h1>Event</h1>
            <div className="top-right">
              <div className="right-top-search">
                <input 
                  type="text" 
                  placeholder="Search..." 
                  autoComplete="off" 
                  className="search-input" 
                  value={searchTerm} 
                  onChange={(e) => setSearchTerm(e.target.value)} 
                />
              </div>

              {/* Filter Dropdown */}
              <select 
                className="filter-dropdown" 
                value={filterCategory} 
                onChange={(e) => setFilterCategory(e.target.value)}
              >
                {filterOptions.map((option) => (
                  <option key={option.id} value={option.id}>{option.name}</option>
                ))}
              </select>

              <div className="add-new-btn">
                <button className="add-new" onClick={openAddModal}>
                  <img src={window.getPublicUrl("/assets/images/add-plus.svg")} alt="" /> Add new
                </button>
              </div>
            </div>
          </div>

          <ul>
            {categories.map((category) => (
              <li
                key={category.id}
                className={activeCategory === category.id ? 'active' : ''}
                onClick={() => setActiveCategory(category.id)}
              >
                <h5>{category.name}</h5>
              </li>
            ))}
          </ul>

          <div className='row'>
            {!loading && !error ? (
              events?.length > 0 ? (
                events.map((event) => (
                  <div className='col-sm-3' key={event.id}>
                    <div className='car-container'>
                      <div className='card' onClick={() => navigate(`detail/${event.id}`)}>
                        {event?.EventImages[0]?.url ? (
                          <img src={event?.EventImages[0]?.url} alt={event.name} className='venue-image' />
                        ) : (
                          <p>No image available</p>
                        )}
                      </div>
                      <div className="car-text">
                        <div className="bottom-section">
                          <h3>{event?.name}</h3>
                          <h3>{event?.Category?.name}</h3>
                          <div className="buttons">
                            <span onClick={() => navigate(`detail/${event.id}`)}>
                              <img src={window.getPublicUrl("/assets/images/view.svg")} alt="" />
                            </span>
                            <button className="edit" onClick={() => openEditVenueModal(event)}>
                              <img src={window.getPublicUrl("/assets/images/edit.svg")} alt="" />
                            </button>
                            <button className="delete" onClick={() => openDeleteUserModal(event)}>
                              <img src={window.getPublicUrl("/assets/images/delete.svg")} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-sm-12">
                  <div className='alert alert-danger'>No Event Found.</div>
                </div>
              )
            ) : null}
          </div>
        </div>

        <Suspense fallback={<div>Loading...</div>}>
          <Modal isOpen={addEventModal} onRequestClose={() => setAddEventModal(false)} contentLabel="Add Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
            overlayClassName="modal-overlay add-venue"
            portalClassName="add-user venuue">
            <AddEventModal setAddEventModal={setAddEventModal} fetchEvents={fetchEvents} />
          </Modal>
        </Suspense>

        <Suspense fallback={<div>Loading...</div>}>
          <Modal isOpen={editModal} onRequestClose={() => setEditModal(false)} contentLabel="Edit Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
            overlayClassName="modal-overlay edit-venue"
            portalClassName="edit-user venuue">
            <EditEventModal setEditModal={setEditModal} eventDetails={selectedEvent} fetchEvents={fetchEvents} />
          </Modal>
        </Suspense>

        <Suspense fallback={<div>Loading...</div>}>
          <Modal isOpen={deleteModal} onRequestClose={() => setDeleteModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
            overlayClassName="modal-overlay add-category delete logout"
            portalClassName="add-user deactivate">
            <DeleteModal setDeleteModal={setDeleteModal} eventDetails={selectedEvent} fetchEvents={fetchEvents} />
          </Modal>
        </Suspense>
      </div>
    </>
  );
}
